import PropTypes from 'prop-types';
import React from 'react';
import startCase from 'lodash/startCase';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import './Breadcrumbs.css';

const Breadcrumbs = ({ routes, className = '' }) => {
  const crumbs = routes
    .filter(route => !!route.path)
    .map((route, index, arr) => {
      const { path, name = startCase(path) } = route;
      const isFirstItem = index === 0;
      const isLastItem = index === arr.length - 1;

      const linkClassName = classnames('dark-gray no-underline', {
        b: isFirstItem,
        normal: !isFirstItem,
      });

      return (
        <li className="dib pa0" key={name}>
          {isLastItem ? (
            <span className={linkClassName}>{name}</span>
          ) : (
            <React.Fragment>
              <Link className={linkClassName + ' Breadcrumbs__link'} to={path}>
                {name}
              </Link>
            </React.Fragment>
          )}
        </li>
      );
    });

  return (
    <div
      className={`Breadcrumbs brandon dark-gray f3 ${className}`}
      data-translate={true}
    >
      <ol className="db ma0 pa0 list">{crumbs}</ol>
    </div>
  );
};

Breadcrumbs.propTypes = {
  routes: PropTypes.array.isRequired,
};

export default Breadcrumbs;



// WEBPACK FOOTER //
// ./src/components/Common/Breadcrumbs.js